import api from "../../services/apis/antecipeApi";
import { Preferences, sanitizePreferences } from "./types";

// PATCH parcial: o BE faz o merge e devolve as preferências resolvidas.
export async function patchPreferences(partial: Partial<Preferences>): Promise<Preferences> {
  const response = await api.patch("me/preferences", partial);
  return sanitizePreferences(response.data?.data);
}
